module.exports = __webpack_public_path__ + "b99dc741e0eac341dee824f3e3baf3e8.pdf";